import Image from 'next/image';
import React from 'react';
import { getStrapiMedia } from '@/lib/media';
import { BodySmall, FootNote } from '@/components/DynamicText';
import Link from 'next/link';

function BlogSmallCard(props: any) {
  const { data } = props;

  return (
    <section className='group mb-[13px] flex justify-start rounded-[12px]  border border-[#eaedf3] p-[10px] transition-shadow hover:shadow-xl dark:border-[#2a3c47] dark:hover:bg-[#263843] xl:min-h-[60px]'>
      <section className='my-auto mr-[12px] max-h-[40px] min-h-[40px] min-w-[40px] max-w-[40px]'>
        {data && (
          <Image
            width={40}
            height={40}
            src={getStrapiMedia(data?.attributes?.card_image)}
            alt='Profile Image'
            className='h-[40px] w-[40px] rounded-[8px]'
          />
        )}
      </section>
      <section className=''>
        {/* title */}
        {data && (
          <BodySmall className=' mb-[2px]  line-clamp-1  font-semibold tracking-[-.3px] text-[#1c2534] dark:text-white'>
            {data?.attributes?.title}
          </BodySmall>
        )}
        {/* author name */}
        {data && (
          <FootNote className=' font-normal tracking-[-.3px] text-[#868f9e] dark:text-[#9ea8ac]'>
            {data?.attributes?.author?.data?.attributes?.name}
          </FootNote>
        )}
      </section>
      <Link
        className=' ml-auto self-center rounded-[18px] border border-[#1c2534] py-[6px] text-center text-[10px] font-semibold text-[#1c2534] group-hover:border-none group-hover:bg-[#00b4b9] group-hover:text-white
            dark:text-white sm:ml-auto sm:min-w-[100px] md:h-[30px] 2xl:ml-auto'
        href={`/${data?.attributes?.slug}`}
      >
        {props.btnName}
      </Link>
    </section>
  );
}

export default BlogSmallCard;
